import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class ErrorsService {
  show(err: HttpErrorResponse, snackbar: MatSnackBar) {
    const errorMessages = this.extractMessages(err);

    errorMessages.forEach((message, index) => {
      setTimeout(() => {
        this.showToast(this.translate(message), snackbar);
      }, index * 2500); 
    });
  }

  showToast(message: string, snackbar: MatSnackBar) {
    snackbar.open(message, 'Ok', {
      horizontalPosition: 'end',
      verticalPosition: 'top',
      duration: 3000,
      panelClass: 'snackbar-error',
    });
  }

  private extractMessages(err: HttpErrorResponse): string[] {
    const messages: string[] = [];

    // Standard Laravel validation shape: { message, errors: { field: [msg] } }
    if (err?.error?.errors && typeof err.error.errors === 'object') {
      Object.keys(err.error.errors).forEach((key) => {
        err.error.errors[key].forEach((message: string) => {
          messages.push(message);
        });
      });
      return messages;
    }

    // Legacy shape: message contains JSON after "Validation Error:"
    if (typeof err?.error?.message === 'string' && err.error.message.includes('Validation Error:')) {
      try {
        const cleanErrorString = err.error.message.replace('Validation Error:', '').trim();
        const errors = JSON.parse(cleanErrorString);
        Object.keys(errors).forEach((key) => {
          errors[key].forEach((message: string) => {
            messages.push(message);
          });
        });
      } catch {
        messages.push(err.error.message);
      }
      return messages;
    }

    if (typeof err?.error?.message === 'string') {
      messages.push(err.error.message);
      return messages;
    }

    messages.push('Ocurrió un error inesperado.');
    return messages;
  }

  private translate(message: string): string {
    const translations: Record<string, string> = {
      'The id number field must be between 8 and 20 digits.': 'El DNI debe tener entre 8 y 20 dígitos.',
      'The id number field is required.': 'El DNI es obligatorio.',
      'The email must be a valid email address.': 'El correo electrónico debe ser válido.',
    };

    return translations[message] ?? message;
  }
}
